import React, { PureComponent } from 'react'
import EditorResolver from './EditorResolver'
import { RowStyled, Column } from '../common/stylesheets/index'

class Row extends PureComponent {
  renderEditResolver = object => (
    <EditorResolver
      object={object}
      {...this.props}
    />
  )
  renderColumns = () => {
    const { row: { object, label }, columnSize } = this.props
    const commonProps = {
      width: 100 / columnSize
    }

    switch (columnSize) {
      // add here more cases if there are more tha 2 columns in the future
      default:
        return (
          <>
            <Column {...commonProps}>
              {label}
            </Column>
            <Column {...commonProps}>
              {this.renderEditResolver(object)}
            </Column>
          </>
        )
    }
  }
  render() {
    return (
      <RowStyled>
        {this.renderColumns()}
      </RowStyled>
    )
  }
}

export default Row
